function stickySumCart() {
    if (!document.querySelector('.js-cart-check-sticky')) return;

    const sumBlock = document.querySelector('.js-cart-check-sticky');
    const headerActions = document.querySelector('.js-site-header-actions');
    const sumBlockWrapper = sumBlock.closest('.js-cart-check-sticky-wrapper');

    headerActions.prepend(sumBlock);

    function checkBlock() {
        if (window.innerWidth > 767) return;

        const offsetTop = sumBlockWrapper.offsetTop;
        const screenBottom = window.scrollY + window.innerHeight;
        const headerActionsHeight =  headerActions.offsetHeight;

        if (screenBottom - headerActionsHeight >= offsetTop) {
            sumBlock.classList.remove('active');
        } else {
            sumBlock.classList.add('active');
        }
    }

    checkBlock();
    window.addEventListener('scroll', checkBlock);
    window.addEventListener('resize', checkBlock);
}
